import { render, staticRenderFns } from "./landPage.vue?vue&type=template&id=448c8600&scoped=true"
import script from "./landPage.vue?vue&type=script&lang=js"
export * from "./landPage.vue?vue&type=script&lang=js"
import style0 from "./landPage.vue?vue&type=style&index=0&id=448c8600&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "448c8600",
  null
  
)

export default component.exports